
import { InjectionToken } from "@angular/core";

import { AdminCustomerAccountFacade } from "./admin-customer-account.facade";

export const ADMIN_CUSTOMER_ACCOUNT_FACADE =
  new InjectionToken<AdminCustomerAccountFacade>('ADMIN_CUSTOMER_ACCOUNT_FACADE');